import { ComponentFactoryResolver, Injectable, ViewContainerRef, } from '@angular/core';

import { OperationsService } from '../../../core/services/operations.service';
import { FascicoloService } from './get-model-fascicolo.service';

/*@Injectable({
  providedIn: 'root'
})*/
@Injectable()
export class DynamicComponentService {
  rootViewContainer: ViewContainerRef;
  rootViewContainerView: ViewContainerRef;
  formComponentDynamic: string;
  viewComponentDynamic: string;
  insert: boolean = true;
  component: any;
  componentView: any;
  constructor(
    private factoryResolver: ComponentFactoryResolver,
    private operationService: OperationsService,
    private fascicoliService: FascicoloService
  ) {}

  public setRootViewContainerRef(viewContainerRef) {
    this.rootViewContainer = viewContainerRef;
  }

  public setRootViewContainerRefView(viewContainerRef) {
    this.rootViewContainerView = viewContainerRef;
  }

  public addDynamicComponent(obj, reset = false) {
    // debugger;
    // console.log(this.formComponentDynamic);
    if (!reset) {
      // this.insert) {
      const factory = this.factoryResolver.resolveComponentFactory(
        this.fascicoliService.getComponentFromFormTenant(
          this.formComponentDynamic
        )
      );
      this.component = factory.create(this.rootViewContainer.parentInjector);

      this.createFormField(obj);

      this.rootViewContainer.insert(this.component.hostView);
      this.insert = false;
    } else {
      this.createFormField(obj);
    }
  }

  removeDynamicComponent(reset) {
    if (this.rootViewContainer.length < 1) return;
    // removing component from container
    if (!reset) {
      const lastIndex = this.rootViewContainer.length - 1;
      this.rootViewContainer.remove(lastIndex);
    }
  }

  removeDynamicComponentView() {
    if (this.rootViewContainerView.length < 1) return;
    // removing component from container
    //this.rootViewContainerView.remove(this.componentView);
    const lastIndex = this.rootViewContainerView.length - 1;
    this.rootViewContainerView.remove(lastIndex);
  }

  private createFormField(obj) {
    this.component.instance.fascicolo = obj.fascicolo;
    this.component.instance.request = obj.request;
    this.component.instance.nomeFascicolo = obj.nomeFascicolo;
    this.component.instance.labelCreatoDaSistema = obj.labelCreatoDaSistema;
    this.component.instance.inserimento = obj.inserimento;
    this.component.instance.wizard = obj.wizard;
    if (!!this.component.instance.createForm) {
      this.component.instance.createForm.subscribe(obj.createForm);
    }
    if (!!this.component.instance.saveForm) {
      this.component.instance.saveForm.subscribe(obj.saveForm);
    }
    if (!!this.component.instance.resetForm) {
      this.component.instance.resetForm.subscribe(obj.resetForm);
    }
  }

  public getFormTenantByTipo(
    idTipopratica,
    idTipoFascicolo,
    obj,
    reset = false
  ) {
    this.operationService
      .getFormTenantByTipo(idTipopratica, idTipoFascicolo)
      .subscribe((response) => {
        this.formComponentDynamic =
          response && response.idFormTenant ? response.idFormTenant : '';
        this.removeDynamicComponent(reset);
        this.addDynamicComponent(obj, reset);
      });
  }

  public getFormTenantByTipoView(
    idTipopratica,
    idTipoFascicolo,
    ctxBodyFascicolo
  ) {
    // debugger;
    this.operationService
      .getFormTenantByTipo(idTipopratica, idTipoFascicolo)
      .subscribe((response) => {
        this.viewComponentDynamic =
          response && response.idFormTenant ? response.idFormTenant : '';
        this.removeDynamicComponentView();
        const factory = this.factoryResolver.resolveComponentFactory(
          this.fascicoliService.getComponentFromFormTenant(
            this.viewComponentDynamic,
            true
          )
        );
        this.componentView = factory.create(
          this.rootViewContainerView.parentInjector
        );
        this.componentView.instance.ctxBodyFascicolo = ctxBodyFascicolo;
        this.rootViewContainerView.insert(this.componentView.hostView);
      });
  }

  updateComponent(objRequest) {
    this.component.instance.request = objRequest.request;
  }
}
